import { OpenInNewOutlined } from '@mui/icons-material';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { enqueueSnackbar } from 'notistack';

import { type DocumentType, graphql } from '@/gql';

const OPEN_FILE_IN_NEW_TAB_MENU_ITEM_FILE_FRAGMENT = graphql(`
  fragment openFileInNewTabMenuItemFileFields on File {
    _id
    folder
    url
    parent {
      _id
    }
  }
`);

interface Props {
  file: DocumentType<typeof OPEN_FILE_IN_NEW_TAB_MENU_ITEM_FILE_FRAGMENT>;
  onClose: () => void;
}

export const OpenFileInNewTabMenuItem = ({ file, onClose }: Props) => {
  const { _id: fileId, folder, url, parent } = file;
  return (
    <MenuItem
      onClick={() => {
        try {
          if (url) {
            window.open(url, '_blank', 'noreferrer,noopener');
          } else {
            const currentUrlWithoutFileId = parent?._id
              ? window.location.href.substring(
                  0,
                  window.location.href.lastIndexOf('/'),
                )
              : window.location.href;

            const openUrl = folder
              ? `${currentUrlWithoutFileId}/${fileId}`
              : `/document/${fileId}/view`;

            window.open(openUrl, '_blank', 'noreferrer,noopener');
          }
        } catch (err) {
          if (!(err instanceof Error)) throw err;

          enqueueSnackbar(
            `There was an error opening the file in a new window or tab - ${err.message}`,
            {
              variant: 'error',
            },
          );
          console.error(err);
        }
        onClose();
      }}
    >
      <ListItemIcon>
        <OpenInNewOutlined />
      </ListItemIcon>
      <ListItemText primary="Open in a new window or tab" />
    </MenuItem>
  );
};
